export function TermsOfWebsiteUse() {
  return (
    <>
      Please read these terms of use carefully before you start to use
      <a href="https://www.cityfalcon.ai" target="_blank" rel="noreferrer"> https://www.cityfalcon.ai</a>
      ,
      <a href="https://www.cityfalcon.co.uk" target="_blank" rel="noreferrer"> https://www.cityfalcon.co.uk</a>
      ,
      <a href="https://www.comparespreadbetting.com" target="_blank" rel="noreferrer"> https://www.comparespreadbetting.com</a>
      ,
      <a href="https://www.financeforfounders.com" target="_blank" rel="noreferrer"> https://www.financeforfounders.com</a>
      ,
      or any other website, app or service owned or operated by City Falcon Limited (all hereinafter referred to as “site”). By using our site, you indicate that you accept these terms of use and that you agree to abide by them. If you do not agree to these terms of use, please refrain from using our site.
      <br />
      <br />
      For the purposes of definitions in this agreement, customers and consumers of our services may be termed “you”, “User”, or “Customer” and references to “us”, “we”, or the “Company” will be to City Falcon Limited
    </>
  );
}

export default TermsOfWebsiteUse;
